<div [ngClass]="'dialog-button-' + company | lowercase">
  <lx-button text="{{ title }}" [buttonStyle]="'plain-text'" [isUnderlined]="true" (buttonClick)="showDialog()"></lx-button>
</div>

<p-dialog [modal]="true" [closable]="true" [(visible)]="dialog" [closeOnEscape]="true" [dismissableMask]="true" appendTo="body" [style]="{ maxWidth: '85vw' }">
  <div class="dialog-body">
    <ng-content></ng-content>
  </div>
</p-dialog>
